import { render, staticRenderFns } from "./CarouselGames.vue?vue&type=template&id=7ba012e8&scoped=true&"
import script from "./CarouselGames.vue?vue&type=script&lang=js&"
export * from "./CarouselGames.vue?vue&type=script&lang=js&"
import style0 from "./CarouselGames.vue?vue&type=style&index=0&id=7ba012e8&prod&scoped=true&lang=scss&"
import style1 from "./CarouselGames.vue?vue&type=style&index=1&id=7ba012e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba012e8",
  null
  
)

export default component.exports